import { useTranslation } from "react-i18next";
import {
  PROGRAMMING,
  COMMENTARY,
  VIDEO,
  OTHER,
  CHECKIN,
} from "../task-constants";

const TAB_TO_EMPTY_KEY = {
  [PROGRAMMING]: "programming",
  [VIDEO]: "video",
  [COMMENTARY]: "commentary",
  [CHECKIN]: "checkIn",
  [OTHER]: "other",
};

const EmptyTasks = ({
  tab,
  organizationCoach,
  selectedTasks,
  referAsClients,
}) => {
  const { t } = useTranslation("coaching-portal");
  const emptyKey = TAB_TO_EMPTY_KEY[tab] || "other";

  const getSubTitle = () => {
    const baseKey = `tasks.empty.${emptyKey}.subTitle`;
    if (emptyKey === "programming") {
      const role = referAsClients
        ? t("tasks.roleArticleClient")
        : t("tasks.roleArticleAthlete");
      return t(baseKey, { role });
    }
    if (emptyKey === "video" || emptyKey === "commentary") {
      const role = referAsClients
        ? t("tasks.rolePluralClients")
        : t("tasks.rolePluralAthletes");
      return t(baseKey, { role });
    }
    if (emptyKey === "checkIn") {
      const role = referAsClients
        ? t("tasks.roleSingularClient")
        : t("tasks.roleSingularAthlete");
      return t(baseKey, { role });
    }
    return t(baseKey);
  };

  return (
    <div className="no-tasks-section">
      <p>{t(`tasks.empty.${emptyKey}.title`)}</p>
      <span>{getSubTitle()}</span>
      <a
        role="button"
        data-button-type="primary"
        href={
          organizationCoach
            ? `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}&organizationCoach=${organizationCoach}`
            : `/coaching-portal/tasks/?modal[type]=add-task&tab=${tab}`
        }
        disabled={selectedTasks.length > 0}
      >
        {t("tasks.empty.addTask")}
      </a>
    </div>
  );
};

export default EmptyTasks;
